import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const userAuthContext = createContext()

export function UserAuthContextProvider({ children }) {
    const [user, setUser] = useState("")

    function logIn(email, password) {
        return signInWithEmailAndPassword(auth, email, password)
    }
    function logOut() {
        return signOut(auth)
    }
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                const userUid = currentUser.uid;

                const publisgerDocRef = doc(db, 'publishers', userUid);
                try {
                    const pubDocSnapshot = await getDoc(publisgerDocRef);
                    if (pubDocSnapshot.exists()) {
                        setUser(currentUser);
                        localStorage.setItem('isPubLoggedIn', true);
                        localStorage.setItem('publisherID', currentUser.uid);
                    } else {
                        console.log('User document does not exist');
                    }
                } catch (error) {
                    console.error('Error checking user document:', error);
                }
            } else {

                setUser(null);
                localStorage.removeItem('publisherID');
                localStorage.removeItem('isPubLoggedIn');
            }
        });

        return () => {
            unsubscribe()
        }
    }, [])

    return (
        <userAuthContext.Provider value={{ user, logIn, logOut }}>
            {children}
        </userAuthContext.Provider>
    )
}

export function useUserAuth() {
    return useContext(userAuthContext)
}